import type { ErrorInfo } from 'react';

import { monitoring } from 'common/services';

/**
 * Reports an error caught by the app's top-level error boundary to Error Tracking. React also logs each
 * crash to the console, which RUM records too, but that copy has no component stack.
 */
export const reportRenderCrash = (error: unknown, componentStack: ErrorInfo['componentStack']) => {
  monitoring.reportError(error, { componentStack });
};
